import { bulkUpdateProgramSettings } from '@wix/ambassador-achievements-programs-v2-program/http';
import { chunk as getChunks } from 'lodash';
const BULK_LIMIT = 100;
export const updateOnlineProgramsCoverImage = async (httpClient, errorHandler, altTextData, onlineProgramsData) => {
  const {
    withErrorHandler
  } = errorHandler;
  if (!onlineProgramsData || !onlineProgramsData.imagesProgramsMap) {
    return {
      success: false
    };
  }
  const allFailedElements = [];
  const chunks = getChunks(altTextData, BULK_LIMIT);
  const requestsArray = chunks.map(chunk => {
    return getUpdateRequestFromChunk(chunk, onlineProgramsData);
  });
  const promiseArray = requestsArray.map(async request => {
    return withErrorHandler(async () => httpClient.request(bulkUpdateProgramSettings(request)), {
      errorCodesMap: {}
    });
  });
  const results = await Promise.allSettled(promiseArray);
  results.forEach((result, index) => {
    var _result$value$data$bu;
    if (result.status === 'rejected') {
      allFailedElements.push(...chunks[index]);
    } else if (((_result$value$data$bu = result.value.data.bulkActionMetadata) == null ? void 0 : _result$value$data$bu.totalFailures) !== 0) {
      var _result$value$data$re;
      (_result$value$data$re = result.value.data.results) == null || _result$value$data$re.forEach(_ref => {
        let {
          itemMetadata
        } = _ref;
        if (!(itemMetadata != null && itemMetadata.success)) {
          (itemMetadata == null ? void 0 : itemMetadata.originalIndex) && allFailedElements.push(chunks[index][itemMetadata.originalIndex]);
        }
      });
    }
  });
  return {
    failedElements: allFailedElements,
    success: true
  };
};
export const getUpdateRequestFromChunk = (chunk, onlineProgramsData) => {
  const programsRequest = chunk.map(altToSet => {
    return {
      mask: ['description.media.image.altText'],
      programId: onlineProgramsData.imagesProgramsMap[altToSet.id],
      programSettings: {
        description: {
          media: {
            image: {
              altText: altToSet.alt
            }
          }
        }
      }
    };
  });
  return {
    programs: programsRequest
  };
};
//# sourceMappingURL=update-online-programs-cover-image-alt.js.map